/**
 * Auth Actions
 *
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 15.04.2016.
 */

import Cookies from 'js-cookie';

import {GetPurchases, GetSubscriptions} from '../purchase/actions-purchase';

export const LOG_IN = 'log-in-with-user-password';
export const LOG_OUT = 'log-out-to-guest-state';
export const REGISTRATION = 'register-new-user';
export const REGISTRATION_CONFIRM = 'register-new-user-confirmation';
export const FORGET_PASSWORD_REQ = 'reset-user-password-request';
export const FORGOTTEN_PASSWORD_CHANGE = 'reset-user-password-to-new';
export const PASSWORD_CHANGE = 'user-change-password-from-old-to-new';

export function LogIn(username, password) {
  let Q;

  Q = lh.extensions.cloud.getSsoKey(Config.sso_url, username, password, Config.operator_ext_id)
    .then(function (response) {
      return lh.system.auth({clientId: Config.client_id, deviceId: Config.device_id}, response);
    })
    .then(() => {

      let user = {
        user: username,
        token: lh.common.config.get('authToken')
      };

      Cookies.set('v2_' + Config.operator_ext_id, user, {expires: 7, path: '/'});

      return user;
    })
    .then((user) => {

      return Promise.all([GetPurchases().payload, GetSubscriptions().payload])
        .then(() => {

          return user;
        })
    });

  return {
    type: LOG_IN,
    payload: Q
  };
}

export function Registration(username, password, firstName, lastName) {

  let Q;

  Q = lh.extensions.cloud.registerNewUser(Config.email_check_url, Config.registration_url, username, password, firstName, lastName, Config.operator_ext_id)
    .then(function (response) {
      if (!response.ssoKey) {
        return {
          needConfirmation: true
        };
      }

      return lh.system.auth({clientId: Config.client_id, deviceId: Config.device_id}, response);
    })
    .then((response) => {
      let user;

      if (response && !!response.needConfirmation) {
        user = {
          user: 'guest',
          token: null,
        };

      } else {
        user = {
          user: username,
          token: lh.common.config.get('authToken')
        };

        Cookies.set('v2_' + Config.operator_ext_id, user, {expires: 7, path: '/'});
      }

      user.needConfirmation = !!response && !!response.needConfirmation;

      return user;
    });

  return {
    type: REGISTRATION,
    payload: Q
  };
}

export function ConfirmRegistration(code) {
  let Q;
  let subscriber;

  Q = lh.extensions.cloud.confirmRegistration(Config.registration_ack_url, code)
    .then(function (response) {
      subscriber = response.subscriber;

      return lh.system.auth({clientId: Config.client_id, deviceId: Config.device_id}, response);
    })
    .then(() => {

      let user = {
        user: subscriber.username,
        token: lh.common.config.get('authToken')
      };

      Cookies.set('v2_' + Config.operator_ext_id, user, {expires: 7, path: '/'});

      return user;
    });

  return {
    type: REGISTRATION_CONFIRM,
    payload: Q
  };

}

export function ForgotPasswordRequest(username) {
  let Q;

  Q = lh.extensions.cloud.forgotPasswordRequest(Config.forget_password_url, username, Config.operator_ext_id);

  return {
    type: FORGET_PASSWORD_REQ,
    payload: Q
  };
}

export function ForgottenPasswordChange(code, pass) {
  let Q;

  if (!code) {
    Q = Promise.reject({
      result: 0,
      message: 'invalid password reset code'
    });
  } else if (!pass) {
    Q = Promise.reject({
      result: 0,
      message: 'password field empty'
    });
  } else if (pass.length < 6) {
    Q = Promise.reject({
      result: 0,
      message: 'password too short'
    });
  } else {
    Q = lh.extensions.cloud.forgottenPasswordChange(Config.forget_password_ack_url, code, pass);
  }

  return {
    type: FORGOTTEN_PASSWORD_CHANGE,
    payload: Q
  };
}

export function PasswordChange(oldPassword, newPassword, newPassword2) {
  let Q;

  if (!oldPassword) {
    Q = Promise.reject({
      result: 0,
      message: 'password field empty'
    });
  } else if (newPassword.length < 6) {
    Q = Promise.reject({
      result: 0,
      message: 'password too short'
    });
  } else if (newPassword !== newPassword2) {
    Q = Promise.reject({
      result: 0,
      message: 'passwords mismatch'
    });
  } else {
    Q = lh.extensions.cloud.passwordChange(Config.password_change_url, oldPassword, newPassword);
  }

  return {
    type: PASSWORD_CHANGE,
    payload: Q
  }
}

export function LogOut() {
  Cookies.remove('v2_' + Config.operator_ext_id);

  return {
    type: LOG_OUT,
    payload: lh.system.auth({clientId: Config.client_id, deviceId: Config.device_id})
      .then(lh.common.comet.close)
      .then(() => {

        return Promise.all([GetPurchases().payload, GetSubscriptions().payload]);
      })
  };
}



// WEBPACK FOOTER //
// ./src/actions/auth/actions-auth.js